import { motion } from "framer-motion";
import { Plane } from "lucide-react";
import { MainSponsor } from "@/components/MainSponsor";

const StatusPill = ({ type, text }) => {
  const map = {
    now: { c: "#A8E6CF", pulse: true },
    next: { c: "#81D4FA", pulse: false },
  };
  const s = map[type] || map.next;
  return (
    <span className="inline-flex items-center gap-2 font-mono text-[10px] sm:text-xs uppercase tracking-widest">
      <span className="relative flex h-2 w-2">
        {s.pulse && (
          <span
            className="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
            style={{ backgroundColor: s.c }}
          />
        )}
        <span
          className="relative inline-flex h-2 w-2 rounded-full"
          style={{ backgroundColor: s.c }}
        />
      </span>
      <span style={{ color: s.c }}>{text}</span>
    </span>
  );
};

// Tablero de salidas de aeropuerto (hero)
export const DepartureBoard = ({ rows }) => {
  return (
    <div className="w-full overflow-hidden rounded-[1.75rem] bg-board p-4 sm:p-6 shadow-[0_30px_60px_rgba(0,0,0,0.25)] ring-1 ring-white/5">
      {/* Cabecera del tablero */}
      <div className="mb-4 flex items-center justify-between border-b border-white/10 pb-3">
        <div className="flex items-center gap-2 font-mono text-[10px] sm:text-xs uppercase tracking-[0.25em] text-mint">
          <Plane className="h-4 w-4 text-coral" strokeWidth={2.5} />
          Salidas · Temporada 1
        </div>
        <div className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.25em] text-white/40">
          Terminal A&B
        </div>
      </div>

      {/* Encabezado de columnas */}
      <div className="grid grid-cols-[38px_1fr_auto] sm:grid-cols-[64px_1fr_auto] gap-3 pb-2 font-mono text-[9px] sm:text-[10px] uppercase tracking-widest text-white/35">
        <span>Ep</span>
        <span>Destino</span>
        <span className="text-right">Estado</span>
      </div>

      <div className="divide-y divide-white/5">
        {rows.map((r, i) => (
          <motion.div
            key={r.n}
            initial={{ opacity: 0, rotateX: -70, y: 8 }}
            animate={{ opacity: 1, rotateX: 0, y: 0 }}
            transition={{
              duration: 0.5,
              delay: 0.5 + i * 0.12,
              ease: [0.22, 1, 0.36, 1],
            }}
            style={{ transformOrigin: "top", transformStyle: "preserve-3d" }}
            className="grid grid-cols-[38px_1fr_auto] sm:grid-cols-[64px_1fr_auto] items-center gap-3 py-2.5 sm:py-3"
          >
            <span
              className="split-flap rounded-md px-1.5 py-1 text-center font-mono text-sm sm:text-lg font-bold text-gold"
            >
              {r.n}
            </span>
            <div className="min-w-0">
              <div className="truncate font-mono text-sm sm:text-lg font-semibold text-white">
                {r.city}
              </div>
              <div className="truncate font-mono text-[10px] sm:text-xs uppercase tracking-widest text-coral/90">
                {r.code} · {r.title}
              </div>
            </div>
            <div className="text-right">
              <StatusPill type={r.statusType} text={r.status} />
            </div>
          </motion.div>
        ))}
      </div>

      <div className="mt-4 flex flex-col items-center gap-3 border-t border-white/10 pt-4">
        <MainSponsor variant="inline" theme="dark" />
        <span className="text-center font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.3em] text-white/30">
          Próximo abordaje · Sábado 20:00 · Occidente MX
        </span>
      </div>
    </div>
  );
};
